import { VERSION } from "./version-constants";
/** Installed from npm on its own schedule: server logs are the only census. */
export function clientHeaders(): Record<string, string> {
  return { "x-hepha-client": `hepha-cli/${VERSION}` };
}
